import PropTypes from 'prop-types';

const InputField = ({ label, error, ...rest }) => (
  <label className="input-field">
    <span>{label}</span>
    <input {...rest} />
    {error && <small>{error}</small>}
  </label>
);

InputField.propTypes = {
  label: PropTypes.string.isRequired,
  error: PropTypes.string,
};

InputField.defaultProps = {
  error: null,
};

export default InputField;
